<header class="flex flex-col gap-1 pb-1.25">
    @if (iconOnly()) {
        <ng-container [ngTemplateOutlet]="iconContent().templateRef" />
    } @else {
        <ng-container [ngTemplateOutlet]="expandedContent().templateRef" />
    }
    <p-splitter />
</header>
